// Shared constants used across the app
export const WHATSAPP_PHONE = "5511920043024";
export const WHATSAPP_MESSAGE =
  "Oi! Gostaria de saber sobre as viagens, quero usar meu cupom TURISTAR";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

export const INSTAGRAM_URL = "https://www.instagram.com/viagensorion";
export const FACEBOOK_URL = "https://www.facebook.com/viagensorion";
export const CADASTUR_URL =
  "https://cadastur.turismo.gov.br/hotsite/#!/public/sou-turista/inicio";
